import { Component } from '@angular/core';

@Component({
    selector: 'angular-datepicker',
    template: ''
})
export class AngularMyDatePickerComponent {}
